/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-13 12:39:21
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-24 15:00:26
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/SectionContainer/index.tsx
 */

import { SectionContainer } from 'src/components/Layouts';

export default SectionContainer;
